import { Category } from "./types";
import { CategorySelectItem } from "@cmp-src/form/CategorySelect/CategorySelectItem";

export interface CategorySelectListProps {
  categories: Category[];
  onSelect: (category: Category) => void;
  onBack?: () => void;
  navigationStack: Category[];
  showPath?: boolean;
  allCategories: Category;
}

const classes = {
  Wrapper: "w-full",
  BackWrapper: "",
  ItemWrapper: "w-full"
};

export const CategorySelectList = ({
  categories,
  onSelect,
  onBack,
  navigationStack,
  showPath,
  allCategories
}: CategorySelectListProps) => {
  const lastNavigation = navigationStack[navigationStack.length - 1];
  const hasBackButton = onBack && !showPath;

  return (
    <div className={classes.Wrapper}>
      {hasBackButton && (
        <div className={classes.BackWrapper}>
          <CategorySelectItem
            key={lastNavigation.id}
            category={lastNavigation}
            onSelect={onBack}
            allCategories={allCategories}
            isBack
          />
        </div>
      )}
      <div className={classes.ItemWrapper}>
        {categories.map((category) => (
          <CategorySelectItem
            key={category.id}
            category={category}
            onSelect={onSelect}
            showPath={showPath}
            isSubCategory={hasBackButton}
            allCategories={allCategories}
          />
        ))}
      </div>
    </div>
  );
};
